import './Organization.scss';
import { useQuery } from '@tanstack/react-query';
import { Loader, Select } from '@trackman/web-shared-components';
import { OrganizationTabsRelativeRoutes } from 'Routes';
import PageTabs from 'components/PageTabs/PageTabs';
import i18next from 'i18next';
import { useServices, useStores } from 'index';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useOrganizationStore } from 'stores/Organization/OrganizationStore';
import useSetPageTitle from 'utilities/useSetPageTitle';

type TabRouteKeys = keyof typeof OrganizationTabsRelativeRoutes;

const organizationTabNamesByRoutes: { [key in TabRouteKeys]: string } = {
  Progress: i18next.t('StudentsProgress', { ns: 'general' }),
  Students: i18next.t('Students', { ns: 'general' }),
  Classes: i18next.t('Classes', { ns: 'studentsPage' }),
} as const;

export const Organization = () => {
  const { t } = useTranslation();
  const cs = useStores().classesStore;
  useSetPageTitle({
    title: t('Organization', { ns: 'general' }),
    subtitle: t('TrackProgressAndCourseCompletion', { ns: 'organizationPage' }),
  });

  const organizationsService = useServices().organizationsService;
  const { data: organizationList, isPending: isOrganizationListPending } = useQuery({
    queryKey: ['organizationList'],
    queryFn: organizationsService.getOrganizations,
    refetchOnWindowFocus: false,
  });

  const setSelectedOrganizationId = useOrganizationStore((state) => state.setSelectedOrganizationId);
  const selectedOrganizationId = useOrganizationStore((state) => state.selectedOrganizationId);

  useEffect(() => {
    if (organizationList && organizationList.length > 0) {
      setSelectedOrganizationId(organizationList[0].id);
    }
  }, [organizationList]);

  useEffect(() => {
    selectedOrganizationId && cs.getClasses(false, selectedOrganizationId);
  }, [selectedOrganizationId]);

  return (
    <>
      {!isOrganizationListPending ? (
        <>
          <div className='select-organization-section'>
            <h2>{t('Organization', { ns: 'general' })}</h2>
            <span>{t('PleaseSelectTheOrganizationYouArePlanningToAdministrate', { ns: 'organizationPage' })}</span>
            <Select
              label={t('Organization', { ns: 'general' })}
              value={selectedOrganizationId}
              error={false}
              onChange={(event) => {
                const selectedOrg = organizationList.find((organization) => organization.id === (event.target.value as string));
                if (selectedOrg) {
                  setSelectedOrganizationId(selectedOrg.id);
                }
              }}
              selectOptions={organizationList.map((organization) => {
                return {
                  label: organization.name === ' ' ? t('PleaseSelectOrganization', { ns: 'organizationPage' }) : organization.name,
                  value: organization.id,
                };
              })}
            />
          </div>
          <div className='organization-tabs-wrapper'>
            <PageTabs tabs={organizationTabNamesByRoutes} defaultTabName={organizationTabNamesByRoutes.Progress} />
          </div>
        </>
      ) : (
        <div className='loader-wrapper'>
          <Loader size='large' />
        </div>
      )}
    </>
  );
};
